export * from './menu.effects';



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/menu/effects/index.ts